import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { push } from'react-router-redux';
import { NavLink, Switch, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import queryString from 'qs';
import isEqual from 'lodash.isequal';
import { ProjectTaskActionCreators, AppActionCreators } from '../../../../actions';
import { RouteUrls } from '../../../../configs/routeUrls';
import { ProjectTaskList } from './ProjectTaskList';
import { ProjectTaskMap } from './ProjectTaskMap';
import {
	PageSize,
	BudgetYearDropdownOption,
	DistrictDropdownOption,
	ThematicAreaDropdownOption,
	ProjectTaskStatusDropdownOption
} from '../../../../utils/enums';

class ProjectTaskListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchTerm: '',
			page: 1,
			size: props.pageSize
		};

		this.prevAction = this.onSearchProjectTasks.bind(this);
		this.nextAction = this.onSearchProjectTasks.bind(this);
	}

	componentDidMount() {
		this.props.setBreadcrumbs([{
			url: RouteUrls.Budget.list.actual,
			displayName: 'Budżet obywatelski'
		}, {

			url: RouteUrls.Budget.projectTasks.list,
			displayName: 'Projekty'
		}])
	}

	componentDidUpdate(prevProps) {
		if (prevProps.pageSize !== this.props.pageSize) {
			this.setState({
				size: this.props.pageSize
			});
		}
	}

	onSearchProjectTasks(filter) {
		this.props.fetchProjectTasks({
			budgetYearId: filter.budgetYearId,
			districtId: filter.districtId,
			officeThematicAreaId: filter.officeThematicAreaId,
			status: filter.status,
			searchTerm: filter.searchTerm,
			page: filter.page,
			size: filter.size
		});
	}

	render() {
		const {
			projectTasks,
			districts,
			budgetYears,
			officeThematicAreas,
			projectTaskStatuses,
			defaultOffice,
			mapConfig,
			isProjectTaskListLoading,
			isProjectTaskSearching,
			totalProjectTasks,
			isOnlyOneOffice = false
		} = this.props;
		let query = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });
		const {
			page = 1,
			budgetYearId = BudgetYearDropdownOption.NotSetted,
			districtId = DistrictDropdownOption.NotSetted,
			officeThematicAreaId = ThematicAreaDropdownOption.NotSetted,
			status = ProjectTaskStatusDropdownOption.NotSetted,
			searchTerm
		} = query;
		const { size } = this.state;
		const totalPages = Math.ceil(this.props.totalProjectTasks / size);

		// const xx = ${queryString.stringify(query, { addQueryPrefix: true })}
		return (
			<div id="content" className="container">
				<div className="top-buttons">
					<NavLink
						className="top-buttons__button"
						to={`${RouteUrls.Budget.projectTasks.list}${queryString.stringify(query, {
							addQueryPrefix: true
						})}`}
						title="Przejdź do listy projektów"
						isActive={(_, { pathname }) => pathname === `${RouteUrls.Budget.projectTasks.list}`}
						activeClassName="top-buttons__button--primary-dark"
					>
						<i className="fas fa-list" aria-hidden="true" />
						<span aria-hidden="true">Lista projektów</span>
					</NavLink>
					<NavLink
						className="top-buttons__button"
						to={`${RouteUrls.Budget.projectTasks.map}${queryString.stringify(query, {
							addQueryPrefix: true
						})}`}
						title="Przejdź do mapy projektów"
						isActive={(_, { pathname }) => pathname === `${RouteUrls.Budget.projectTasks.map}`}
						activeClassName="top-buttons__button--primary-dark"
					>
						<i className="fas fa-map-marked-alt" aria-hidden="true" />
						<span aria-hidden="true">Mapa projektów</span>
					</NavLink>
				</div>
				<div className="project-tasks">
					{this.props.children}
					<Route
						path={RouteUrls.Budget.projectTasks.list}
						render={() => (
							<ProjectTaskList
								projectTasks={projectTasks}
								isProjectTaskListLoading={isProjectTaskListLoading}
								isProjectTaskSearching={isProjectTaskSearching}
								districts={districts}
								budgetYears={budgetYears}
								officeThematicAreas={officeThematicAreas}
								projectTaskStatuses={projectTaskStatuses}
								defaultOffice={defaultOffice}
								page={page}
								size={size}
								budgetYearId={parseInt(budgetYearId)}
								districtId={parseInt(districtId)}
								officeThematicAreaId={parseInt(officeThematicAreaId)}
								status={parseInt(status)}
								searchTerm={searchTerm}
								totalProjectTasks={totalProjectTasks}
								totalPages={totalPages}
								nextAction={this.nextAction}
								prevAction={this.prevAction}
								filter={query}
								changePageSize={this.props.setPageSize}
								fetchProjectTasks={this.props.fetchProjectTasks}
								isOnlyOneOffice={isOnlyOneOffice}
							/>
						)}
					/>
					<Route
						path={RouteUrls.Budget.projectTasks.map}
						render={() => (
							<ProjectTaskMap
								mapConfig={mapConfig}
								projectTasks={projectTasks}
								isProjectTaskListLoading={isProjectTaskListLoading}
								isProjectTaskSearching={isProjectTaskSearching}
								districts={districts}
								budgetYears={budgetYears}
								officeThematicAreas={officeThematicAreas}
								projectTaskStatuses={projectTaskStatuses}
								defaultOffice={defaultOffice}
								fetchProjectTasks={this.props.fetchProjectTasks}
								budgetYearId={parseInt(budgetYearId)}
								districtId={parseInt(districtId)}
								officeThematicAreaId={parseInt(officeThematicAreaId)}
								status={parseInt(status)}
								searchTerm={searchTerm}
							/>
						)}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isProjectTaskListLoading: state.projectTask.isProjectTaskListLoading,
		isProjectTaskSearching: state.projectTask.isProjectTaskSearching,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		projectTasks: state.projectTask.projectTasks,
		totalProjectTasks: state.projectTask.totalProjectTasks,
		mapConfig: state.app.mapConfiguration || {
			zoom: 13,
			latitude: 51.215933,
			longitude: 19.134422
		},
		budgetYears: state.app.availableBudgetYears,
		districts: state.app.districts,
		officeThematicAreas: state.app.officeThematicAreas,
		defaultOffice: state.app.defaultOffice,
		projectTaskStatuses: state.app.projectTaskStatuses,
		filter: ownProps.location.query,
		pageSize: state.app.pageSize,
		breadcrumbs: state.app.breadcrumbs,
		location: state.routing.location
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...ProjectTaskActionCreators, ...AppActionCreators }, dispatch),
		...{ goTo: (url) => dispatch(push(url)) }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTaskListContainer);
